import { createContext, useContext } from 'react';
import { CheckoutContextValue } from 'src/context/CheckoutProvider/CheckoutProvider.types';

export const checkoutInitialState = {
  paymentMethod: undefined,
  deliveryMethodInfo: undefined,
  observations: undefined,
  useWalletCredits: false,
};

export const CheckoutContext = createContext<CheckoutContextValue>({
  amount: 0,
  setCard: () => {},
  setPaymentMethod: () => {},
  setDeliveryMethodInfo: () => {},
  disableCreateOrder: true,
  summary: {
    total: 0,
    subtotal: 0,
    delivery: 0,
    couponDiscount: 0,
    productsDiscount: 0,
    walletCreditsUsed: 0,
  },
  resetCheckoutState: () => {},
  setObservations: () => {},
  setUseWalletCredits: () => {},
  ...checkoutInitialState,
});

export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext);

  if (context === undefined) {
    throw new Error(
      'useCheckoutContext must be used within an CheckoutProvider'
    );
  }

  return context;
};
